import { ViewContainerRef } from "@angular/core";
import { WagtailAccordionComponent } from "./elements/accordion/accordion.component";
import { WagtailButtonComponent } from "./elements/button/button.component";
import { WagtailFullBleedSliderComponent } from "./elements/full-bleed-slider/full-bleed-slider.component";
import { WagtailHtmlComponent } from "./elements/html/html.component";
import { WagtailImageComponent } from "./elements/image/image.component";
import { WagtailRichtextComponent } from "./elements/richtext/richtext.component";
import { ShopBannerComponent } from "./elements/shop-banner/shop-banner.component";
import { ShopCardComponent } from "./elements/shop-card/shop-card.component";
import { WagtailCMSCardsComponent } from "./elements/shop-cmscards/shop-cmscards.component";
import { ShopFullbleed2ColComponent } from "./elements/shop-fullbleed2col/shop-fullbleed2col.component";
import { ShopImagesliderComponent } from "./elements/shop-imageslider/shop-imageslider.component";
import { ShopImageRichtextComponent } from "./elements/shop-imgrte/shop-imgrte.component";
import { ShopNewsletterComponent } from "./elements/shop-newsletter/shop-newsletter.component";
import { ShopRichtextComponent } from "./elements/shop-richtext/shop-richtext.component";
import { ShopSimpleTitleComponent } from "./elements/shop-simple-title/shop-simple-title.component";
import { WagtailTilesComponent } from "./elements/tiles/tiles.component";
import { WagtailTwoColumnsComponent } from "./elements/two-columns/two-columns.component";
import { WagtailTwoLanComponent } from "./elements/two-lan/two-lan.component";
import {
  PictureTagInfoInterface,
  WagtailAccordionRendererInterface,
  WagtailButtonRendererInterface,
  WagtailCMSCardsRendererInterface,
  WagtailFullbleed2ColRenderInterface,
  WagtailHtmlRendererInterface,
  WagtailImageRichtextInterface,
  WagtailImageSliderRenderInterface,
  WagtailPageContentElementInterface,
  WagtailPageContentRendererInterface,
  WagtailRichtextRendererInterface,
  WagtailShopBannerRendererInterface,
  WagtailShopCardRendererInterface,
  WagtailShopRichtextRendererInterface,
  WagtailSimpleTitleInterface,
  WagtailTilesRendererInterface,
  WagtailTwoColumnsRendererInterface,
  WagtailTwoLanRendererInterface
} from "@gea-waldviertler-website/gea-models";

export class WagtailContentRendererFactory {
  public static renderContentElement(
    referenceContainer: ViewContainerRef | undefined,
    contentElement: WagtailPageContentElementInterface<WagtailPageContentRendererInterface>
  ) {
    if (! referenceContainer) return

    switch (contentElement.type) {
      case 'rich_text':
        referenceContainer.createComponent(WagtailRichtextComponent)
          .setInput('definition', contentElement as WagtailPageContentElementInterface<WagtailRichtextRendererInterface>)
        break
      case 'button':
        referenceContainer.createComponent(WagtailButtonComponent)
          .setInput('definition', contentElement as WagtailPageContentElementInterface<WagtailButtonRendererInterface>)
        break
      case 'accordion':
        referenceContainer.createComponent(WagtailAccordionComponent)
          .setInput('definition', contentElement as WagtailPageContentElementInterface<WagtailAccordionRendererInterface>)
        break
      case 'shop_richtext':
        referenceContainer.createComponent(ShopRichtextComponent)
          .setInput('definition', contentElement as WagtailPageContentElementInterface<WagtailShopRichtextRendererInterface>)
        break
      case 'html':
        referenceContainer.createComponent(WagtailHtmlComponent)
          .setInput('definition', contentElement as WagtailPageContentElementInterface<WagtailHtmlRendererInterface>)
        break
      case 'landing_full_bleed_slider':
        referenceContainer.createComponent(WagtailFullBleedSliderComponent)
          .setInput('definition', contentElement as WagtailPageContentElementInterface<WagtailFullBleedSliderComponent>)
        break
      case 'col_2':
        referenceContainer.createComponent(WagtailTwoColumnsComponent)
          .setInput('definition', contentElement as WagtailPageContentElementInterface<WagtailTwoColumnsRendererInterface>)
        break
      case 'lan_2':
      case 'shop_2colcard':
        referenceContainer.createComponent(WagtailTwoLanComponent)
          .setInput('definition', contentElement as WagtailPageContentElementInterface<WagtailTwoLanRendererInterface>)
        break
      case 'image':
        referenceContainer.createComponent(WagtailImageComponent)
          .setInput('definition', contentElement as WagtailPageContentElementInterface<PictureTagInfoInterface>)
        break
      case 'tiles':
        referenceContainer.createComponent(WagtailTilesComponent)
          .setInput('definition', contentElement as WagtailPageContentElementInterface<WagtailTilesRendererInterface>)
        break
      case 'horizontal_ruler':
        this.initHorizontalRulerContent(referenceContainer)
        break
      case 'shop_cmscards':
        referenceContainer.createComponent(WagtailCMSCardsComponent)
          .setInput('definition', contentElement as WagtailPageContentElementInterface<WagtailCMSCardsRendererInterface>)
        break
      case 'shop_banner':
        referenceContainer.createComponent(ShopBannerComponent)
          .setInput('definition', contentElement as WagtailPageContentElementInterface<WagtailShopBannerRendererInterface>)
        break
      case 'shop_card':
        referenceContainer.createComponent(ShopCardComponent)
          .setInput('definition', contentElement as WagtailPageContentElementInterface<WagtailShopCardRendererInterface>)
        break
      case 'shop_newsletter':
        referenceContainer.createComponent(ShopNewsletterComponent)
        break
      case 'shop_imageslider':
        referenceContainer.createComponent(ShopImagesliderComponent)
          .setInput('definition', contentElement as WagtailPageContentElementInterface<WagtailImageSliderRenderInterface>)
        break
      case 'shop_fullbleed2col':
        referenceContainer.createComponent(ShopFullbleed2ColComponent)
          .setInput('definition', contentElement as WagtailPageContentElementInterface<WagtailFullbleed2ColRenderInterface>)
        break
      case 'shop_imgrte':
        referenceContainer.createComponent(ShopImageRichtextComponent)
          .setInput('definition', contentElement as WagtailPageContentElementInterface<WagtailImageRichtextInterface>)
        break
      case 'shop_titlesimple':
        referenceContainer.createComponent(ShopSimpleTitleComponent)
          .setInput('definition', contentElement as WagtailPageContentElementInterface<WagtailSimpleTitleInterface>)
        break
      case 'spacer':
        this.initSpacerContent(referenceContainer)
        break
      default:
    }
  }

  private static initHorizontalRulerContent(referenceContainer: ViewContainerRef) {
    let ref = referenceContainer.createComponent(WagtailHtmlComponent)
    if (! ref) return
    let contentElement: WagtailPageContentElementInterface<WagtailHtmlRendererInterface> = {
      id: '',
      value: { html: '<hr />' },
      type: ''
    }
    
    ref.setInput('definition', contentElement)
  }

  private static initSpacerContent(referenceContainer: ViewContainerRef) {
    let ref = referenceContainer.createComponent(WagtailHtmlComponent)
    if (! ref) return
    let contentElement: WagtailPageContentElementInterface<WagtailHtmlRendererInterface> = {
      id: '',
      value: { html: '<br />' },
      type: ''
    }

    ref.setInput('definition', contentElement)
  }
}